import '../../Styles/ValuatorStyles/QuestionComponent.css'
import { useEffect, useState } from 'react';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase-config';

function QuestionComponent({companyID}) {
    const [customerQuestions, setCustomerQuestions] = useState({});
    const [internalQuestions, setInternalQuestions] = useState({});
    const [categories, setCategories] = useState({});
    const [isModified, setIsModified] = useState(false); 
    
    useEffect(() => {
        const fetchQuestions = async () => {
            if (companyID) {
                try {
                    const customerQuestionsRef = doc(db, "companies", companyID, "questions", "HJKoNf2eABC3ONUGtRbS");
                    const customerQuestionsDoc = await getDoc(customerQuestionsRef);
                    if (customerQuestionsDoc.exists()) {
                        setCustomerQuestions(customerQuestionsDoc.data());
                    } else {
                        console.log("No customer questions found");
                    }
                    const categoryIDs = ["cat1", "cat2", "cat3", "cat4", "cat5"];
                    let fetchedCategories = {};
    
                    for (const id of categoryIDs) {
                        const categoryRef = doc(db, "companies", companyID, "questions", id);
                        const categoryDoc = await getDoc(categoryRef);
                        if (categoryDoc.exists()) {
                            fetchedCategories[id] = categoryDoc.data();
                        } else {
                            console.log(`No questions found for category ID: ${id}`);
                        }
                    }
    
                    setCategories(fetchedCategories);
                } catch (error) {
                    console.error("Error fetching questions:", error);
                }
            }
        };
    
        fetchQuestions();
    }, [companyID]);
    
    
    
    const handleQuestionChange = (e, questionSetID, questionKey, isInternal) => {
        const newValue = e.target.value;

        if (isInternal) {
            const updatedCategories = {
                ...categories,
                [questionSetID]: {
                    ...categories[questionSetID],
                    [questionKey]: {
                        ...categories[questionSetID][questionKey],
                        text: newValue
                    }
                }
            };
            setCategories(updatedCategories);
        } else {
            const updatedCustomerQuestions = {
                ...customerQuestions,
                [questionKey]: {
                    ...customerQuestions[questionKey],
                    text: newValue
                }
            };
            setCustomerQuestions(updatedCustomerQuestions);
        }
        setIsModified(true);
    };
    
    
    
    const handleCheckboxChange = (e, categoryID, questionID) => {
        const updatedCategories = {
            ...categories,
            [categoryID]: {
                ...categories[categoryID],
                [questionID]: {
                    ...categories[categoryID][questionID],
                    isSelected: e.target.checked
                }
            }
        };
        setCategories(updatedCategories);
        setIsModified(true);
    };
    

    const saveQuestions = async () => {
        try {
            if (isModified) {
                // Save customer questions
                if (customerQuestions) {
                    const customerQuestionsRef = doc(db, "companies", companyID, "questions", "HJKoNf2eABC3ONUGtRbS");
                    await setDoc(customerQuestionsRef, customerQuestions);
                }
                
                // Save internal questions for each category
                for (const [catID, questions] of Object.entries(categories)) {
                    const categoryRef = doc(db, "companies", companyID, "questions", catID);
                    await setDoc(categoryRef, questions);
                }
                
                alert("All questions updated successfully!");
                setIsModified(false);
            }
        } catch (error) {
            console.error("Error updating questions:", error);
            alert("Error updating questions.");
        }
    };
    
    

    return (
        <>
        <div className="questions-section">
            <h3>Kunde Spørgsmål</h3>
            {Object.entries(customerQuestions)
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
    .map(([key, questionObj]) => (
        <div key={key} className="question-item">
            <label htmlFor={key}>{key}</label>
            <input
                type="text"
                id={key}
                value={questionObj.text || ''}
                onChange={(e) => handleQuestionChange(e, "customerQuestionsId", key, false)}
            />
        </div>
    ))
}

        </div>
            <div className="questions-section">
                <h3>Interne Evalueringsspørgsmål</h3>
                {Object.entries(categories).map(([categoryID, questions]) => (
                    <div key={categoryID} className="questions-section">
                        <h3>{`Category ${categoryID.toUpperCase()}`}</h3>
                        {Object.entries(questions)
                            .sort(([keyA], [keyB]) => {
                                const numA = parseInt(keyA.match(/\d+/)?.[0], 10) || 0;
                                const numB = parseInt(keyB.match(/\d+/)?.[0], 10) || 0;
                                return numA - numB;
                            })
                            .map(([questionID, questionData]) => (
                                <div key={questionID} className="question-item">
                                    <label htmlFor={`text-${categoryID}-${questionID}`}>
                                        {`Question ${questionID.match(/\d+/)?.[0] || ''}`}
                                    </label>
                                    <input
                                        type="text"
                                        id={`text-${categoryID}-${questionID}`}
                                        value={questionData.text || ''}
                                        onChange={(e) => handleQuestionChange(e, categoryID, questionID, true)}
                                    />
                                   <label htmlFor={`checkbox-${categoryID}-${questionID}`} className="custom-checkbox-label">
    <input
        type="checkbox"
        id={`checkbox-${categoryID}-${questionID}`}
        checked={questionData.isSelected || false}
        onChange={(e) => handleCheckboxChange(e, categoryID, questionID)}
    />
    <span className="custom-checkbox"></span>
</label>
                                </div>
                            ))
                        }
                    </div>
                ))}
                <button onClick={saveQuestions} disabled={!isModified} className="save-questions-button">Gem</button>
            </div>
        </>
    );
}

export default QuestionComponent;
